export default {
  namespaced: true,
  state: {
    showVideoCallTip: false, // 显示视频邀请提示框
    showVideoCallView: false // 显示视频通话
  },
  mutations: {
    setVideoCallTip(state, flag) {
      state.showVideoCallTip = flag
    },
    setVideoCallView(state, flag) {
      state.showVideoCallView = flag
    }
  }
}
